import type { ComponentType, SVGProps } from 'react';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { FaWhatsapp } from 'react-icons/fa6';
import { CLIENT_ROUTES } from '../../../shared/constants/routes.constants';
import { SETTINGS_KEYS } from '../../../shared/constants/settings.constants';
import { generatePath } from '../../../shared/services/app.shared-service';

export const linksMoreItems: {
	href: string;
	title: string;
	description: string;
}[] = [
	{
		href: generatePath({
			route: [CLIENT_ROUTES.PRODUCTS.BASE, CLIENT_ROUTES.PRODUCTS.SALE],
		}),
		title: 'sale',
		description: 'saleDescription',
	},
	{
		href: generatePath({
			route: [CLIENT_ROUTES.ABOUT_US],
		}),
		title: 'aboutUs',
		description: 'aboutUsDescription',
	},
	{
		href: generatePath({
			route: [CLIENT_ROUTES.CONTACT],
		}),
		title: 'contact',
		description: 'contactDescription',
	},
	{
		href: generatePath({
			route: [CLIENT_ROUTES.QNA],
		}),
		title: 'qna',
		description: 'qnaDescription',
	},
];

export const linksSocialItems: {
	key: SETTINGS_KEYS;
	title: string;
	icon: ComponentType<SVGProps<SVGSVGElement>>;
}[] = [
	{
		key: SETTINGS_KEYS.FACEBOOK_URL,
		title: 'facebook',
		icon: FaFacebookF,
	},
	{
		key: SETTINGS_KEYS.INSTAGRAM_URL,
		title: 'instagram',
		icon: FaInstagram,
	},
	{
		key: SETTINGS_KEYS.WHATSAPP_NUMBER,
		title: 'whatsApp',
		icon: FaWhatsapp,
	},
];
